module.exports = __webpack_public_path__ + "img/como_funciona.7022b44f.jpg";